import type { ReactNode } from "react";

export const ReviewInfoField = ({
  label,
  value,
}: {
  label: string;
  value: ReactNode;
}) => (
  <div className="col-md-6 mb-3">
    <div className="text-muted small">{label}</div>
    {/* Filnavne er ofte ét langt ord uden mellemrum, som ellers løber ind i
        nabokolonnen. */}
    <div className="fw-semibold text-break">{value}</div>
  </div>
);

export const ReviewInfoCard = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <div className="c-card pt-4">
    <h3 className="mb-3">{title}</h3>
    <div className="row">{children}</div>
  </div>
);
